<template>
  <el-dialog
    :title="model.title || '质保判定'"
    :visible.sync="visible"
    width="600px"
    @close="$emit('update:show', false)"
    @open="opened()"
  >
    <el-form
      ref="form"
      label-position="top"
      label-width="90px"
      :model="model"
      :rules="formRules"
    >
      <el-form-item
        :label="model.desc || '是否在质保期'"
        prop="in_repair_scope"
      >
        <template v-if="model.mode_status == 111">
          <div>
            <!-- <el-radio v-model="model.in_repair_scope" :label="1" border
              >提供备件清单</el-radio
            > -->
            <el-radio v-model="model.in_repair_scope" :label="2" border
              >工程师上门</el-radio
            >
            <el-radio v-model="model.in_repair_scope" :label="3" border
              >沟通完成，无需派工</el-radio
            >
          </div>
        </template>
        <template v-else-if="model.mode_status == 9">
          <el-form-item label="" prop="remark">
            <el-input v-model="model.remark"></el-input>
          </el-form-item>
        </template>
        <template v-else>
          <el-radio v-model="model.in_repair_scope" :label="1">是</el-radio>
          <el-radio v-model="model.in_repair_scope" :label="0">否</el-radio>
        </template>
      </el-form-item>
      <el-form-item
        label="是否给保"
        prop="give_insurance"
        v-if="
          model.mode_status == 5 ||
          model.mode_status == 10 ||
          model.mode_status == 113
        "
      >
        <el-radio v-model="model.give_insurance" :label="1">是</el-radio>
        <el-radio v-model="model.give_insurance" :label="2">否</el-radio>
      </el-form-item>
      <el-form-item
        label="沟通内容"
        prop="remark"
        v-if="model.mode_status == 111 && model.in_repair_scope == 3"
      >
        <el-input
          style="width: 84%"
          type="textarea"
          :rows="4"
          v-model="model.remark"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submiting"
        @click="submitForm"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { serviceQuestDone, userList } from '../service/getData'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
    model() {},
  },
  data() {
    return {
      visible: this.show,
      formRules: {
        remark: [
          {
            required: true,
            message: '请输入内容',
            trigger: 'change',
          },
        ],
      },
      submiting: false,
      users: [],
    }
  },
  methods: {
    async requestUsers() {
      let data = { page: 0, size: 1000 }
      let res = await userList(data)
      if (res.code == 0) {
        this.users = res.data.list
      }
    },
    opened() {},
    submitForm() {
      let self = this
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          self.submiting = true
          let res = await serviceQuestDone(this.model)
          if (res.code == 0) {
            self.$emit('refresh')
          }
          self.submiting = false
          self.visible = false
        } else {
          self.submiting = false
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>